module.exports = __webpack_public_path__ + "img/fahrzeug.49394d40.png";